'use strict';

import ContentBlockServiceInterface from '../interfaces/icontent-block-service';

export default class ContentBlockHTTPService extends ContentBlockServiceInterface {
  constructor(http, routes) {
    super()
    this.http = http;
    this.routes = routes;
  }
  getAllContentBlocks() {
    return this.http.get(this.routes.getAllContentBlocks);
  }
  getContentBlockById() {
    return this.http.get(this.routes.getContentBlockById);
  }
  addContentBlock(contentBlock) {
    return this.http.post(this.routes.addContentBlock, null, null, contentBlock);
  }
  updateContentBlock(contentBlock) {
    return this.http.patch(this.routes.updateContentBlock, {
      id: contentBlock.id
    }, null, contentBlock);
  }
}
